var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var MONITORING_SET_MODE = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation MonitoringSetMode($electionEventId: uuid!, $mode: String!) {\n        monitoringSetMode(election_event_id: $electionEventId, mode: $mode) {\n            mode\n            generation\n        }\n    }\n"], ["\n    mutation MonitoringSetMode($electionEventId: uuid!, $mode: String!) {\n        monitoringSetMode(election_event_id: $electionEventId, mode: $mode) {\n            mode\n            generation\n        }\n    }\n"])));
var templateObject_1;
